export default function () {
  return {
    accessToken: null,
    refreshToken: null,
    expirationTime: null,
    userData: null,
  };
}
